var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('loading',{attrs:{"active":_vm.isLoading,"is-full-page":_vm.fullPageLoader,"color":_vm.loaderColor},on:{"update:active":function($event){_vm.isLoading=$event}}}),_c('h4',{staticClass:"text-lg font-bold mb-8"},[_vm._v(_vm._s(_vm.$t('frontend_more')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }